import React from 'react';
import moment from 'moment-timezone';
import ReactTable from "react-table";
import { AlertsService, TimeFormattingService } from '../../services';
import { Redirect } from 'react-router-dom';
import i18next from "i18next";

class AssetDetailReportAlerts extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      grouping: this.props.query.location.grouping,
      data: [],
      pages: null,
      loading: true,
      totalElements: null,
    }

    this.refresh = this.refresh.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.datafetched = this.datafetched.bind(this);
    this.makeDatatableRequest = this.makeDatatableRequest.bind(this);
  }

  componentDidUpdate(prevProps) {
    if(prevProps.query !== this.props.query) {
      this.refresh();
    }
  }

  refresh () {
    if (this.refs.alertsTable) {
        this.fetchData(this.refs.alertsTable)
    }
  }

  componentDidMount() {
    this.refresh()
  }

  makeDatatableRequest (data, callback, _) {
    const DATE_FORMAT = 'L';
    let {startAtDate, endAtDate, entity} = this.props.query;

    if (this.state.grouping?.timezone) {
        var offset = moment(startAtDate, DATE_FORMAT).tz(this.state.grouping?.timezone).utcOffset();
        startAtDate = moment(startAtDate, DATE_FORMAT).utc().startOf("day").valueOf() - offset * 60 * 1000;
        offset = moment(endAtDate, DATE_FORMAT).tz(this.state.grouping?.timezone).utcOffset();
        endAtDate = moment(endAtDate, DATE_FORMAT).utc().endOf("day").valueOf() - offset * 60 * 1000;
    } else {
        startAtDate = moment(startAtDate, DATE_FORMAT).startOf("day").valueOf();
        endAtDate = moment(endAtDate, DATE_FORMAT).endOf("day").valueOf();
    }

    let options = [
      { 'size': data.pageSize },
      { 'page': data.page }
    ];

    let neworder = data.sorted ? data.sorted : this.refs.alertsTable ? this.refs.alertsTable.state.sorted :  null;

     if (neworder && neworder.length > 0) {
       neworder.forEach(order => {
         options.push({ 'sort': `${order.id},${order.desc ? "desc":"asc"}` });
       })
     }

    if (entity) {
        const ids = [entity.value];
        if (entity.entityTypeToken == 'device') {
          options.push({ filterByDeviceIds: ids });
        } else {
          options.push({ filterByAssetIds: ids });
        }
    }

    // TODO this only works because we have only two levels in our pilots right
    // now, in the future we will need to mark a grouping as usable in filtering
    if(this.props.location && this.props.location.state && this.props.location.state.grouping) {
      options.push({ 'filterByGroupingId': this.props.location.state.grouping.id })
    } else if (this.props.currentGrouping && this.props.currentGrouping.parent) {
      options.push({ 'filterByGroupingId': this.props.currentGrouping.id });
    }

    if (startAtDate && endAtDate) {
      options.push({ 'startAtDate': startAtDate});
      options.push({ 'endAtDate': endAtDate});
    }

    AlertsService.getAll(options).then(response => {
      callback({
        data: response.alerts,
        recordsTotal: response.page.totalElements,
        recordsFiltered: response.page.totalElements,
      });
    }).catch(error => {
      console.error(error);
      this.state.localErrorHandler(error.message);
    });
  }

  datafetched(res) {
    let size = this.refs.alertsTable.state.pageSize;
    let page = this.refs.alertsTable.state.page;
    this.setState({
      data: res.data,
      pages: Math.ceil(res.recordsTotal / size),
      page: page,
      pageSize: size,
      loading: false,
      totalElements: res.recordsTotal
    }, () => this.props.dataFetched());
  }

  fetchData(state) {
    this.setState({
      loading: true
    });
    this.makeDatatableRequest(state, this.datafetched, null);
  }

  renderArea(cell) {
    let data = cell.value
    return <span>{data ? (data.filter(tag => tag.tagType && tag.tagType.token === 'area').map(tag => tag.name).join(' ') ) : ''}</span>;
  }

  renderLevel(cell) {
    let className = 'criticality-indicator criticality-'+cell.value.token
    return <span className={className}>{cell.value.name}</span>
  }

  renderNormalTime(data) {
    let date = TimeFormattingService.renderDate(data.value, data.original.timezone ? data.original.timezone : null);
    let time = TimeFormattingService.renderTime(data.value, data.original.timezone ? data.original.timezone : null);
    return <span>{date}<br/>{time}</span>;
  }

  render() {
    if (this.state.linkTo) {
      return <Redirect push to={{
        pathname: this.state.linkTo,
        state: {
          history: "/monitoring/locations/events"
        }
      }}/>
    }

    if (this.state.grouping) {
      const { data, pages, loading, totalElements } = this.state;

      return (
            <div className="op-content-box">
              <div className="l-region__heading">
                <h2> Events </h2>
              </div>
                  <div className="react-table-custom">
                    <ReactTable
                      className="-striped -highlight"
                      ref="alertsTable"
                      manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                      data={data}
                      pages={pages} // Display the total number of pages
                      loading={loading} // Display the loading overlay when we need it
                      showPaginationTop
                      totalElements={totalElements}
                      onFetchData={this.fetchData}
                      columns={[
                                  {
                                    Header: i18next.t('table-headers.category'),
                                    accessor: "deviceDataType.name",
                                    sortable: false,
                                    minResizeWidth: 50
                                  },
                                  {
                                    Header: i18next.t('table-headers.level'),
                                    accessor: "alertLevel",
                                    Cell: cell => this.renderLevel(cell),
                                    sortable: true,
                                    minResizeWidth: 50
                                  },
                                  {
                                    Header: i18next.t('table-headers.status'),
                                    accessor: "alertStatus.description",
                                    sortable: false,
                                    minResizeWidth: 50
                                  },
                                  {
                                    Header: i18next.t('table-headers.time'),
                                    accessor: "occurredAt",
                                    Cell: cell => this.renderNormalTime(cell),
                                    sortable: true,
                                    minResizeWidth: 50
                                  },
                                  {
                                    Header: i18next.t('table-headers.area'),
                                    accessor: "originatingDevice.tags",
                                    Cell: cell => this.renderArea(cell) ,
                                    sortable: false,
                                    minResizeWidth: 50
                                  },
                                  {
                                    Header: i18next.t('table-headers.description'),
                                    accessor: "description",
                                    sortable: false,
                                    minResizeWidth: 50,
                                    width: 200
                                  }
                                ]}
                      defaultSorted={[
                                {
                                  id: "occurredAt",
                                  desc: true
                                }
                              ]}
                    />
                  </div>
            </div>
      );

    } else {
      return (
          <div className="loader">{ i18next.t('loading') }</div>
      );
    }
  }
}

export default AssetDetailReportAlerts;
